module.exports = __webpack_public_path__ + "static/img/入口.e2ea518.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/入口.gif
// module id = z1EX
// module chunks = 3